import React from 'react';
import { useScrollContext } from './ScrollableTableWrapper';

const Thead = ({champsHeader, pathname}) => {
    const { hasHorizontalScroll = false, hoveredRowId } = useScrollContext();
    const isCompanyPage = pathname && pathname.includes('company');
    const isQualificationPage = pathname && pathname.includes('qualification');
    const isNocompletedPage = pathname && pathname.includes('nocompleted');
    const headerPyClass = isCompanyPage ? 'py-2.5' : 'py-3.5';
    
    // Définir les largeurs minimales pour les colonnes de relevés d'heures et viviers
    const getMinWidthClass = (index, headerText, pathname) => {
        // Si c'est une table de relevés d'heures (timeSheet ou hours)
        if (pathname && (pathname.includes('timeSheet') || pathname.includes('hours'))) {
            const minWidths = {
                0: 'min-w-[140px]', // N° DE RELEVÉ
                1: 'min-w-[250px]', // ENTREPRISE / RAISON SOCIALE
                2: 'min-w-[250px]', // MISSION / POSTE
                3: 'min-w-[160px]', // N° DE MISSION
                4: 'min-w-[220px]', // INTÉRIMAIRE
                5: 'min-w-[200px]', // ÉTAT / PÉRIODE
                6: 'min-w-[200px]', // PÉRIODE (si présent)
            };
            return minWidths[index] || '';
        }
        // Si c'est une table de viviers (rating-treated ou rating-untreated)
        if (pathname && (pathname.includes('rating-treated') || pathname.includes('rating-untreated'))) {
            const minWidths = {
                0: 'min-w-[220px]', // INTÉRIMAIRE
                1: 'min-w-[250px]', // MISSION
                2: 'min-w-[300px]', // MOTIF
                3: 'min-w-[200px]', // RESPONSABLE
            };
            return minWidths[index] || '';
        }
        return '';
    };

    // Définir les largeurs pour les colonnes
    const getWidthClass = (index, headerText, pathname) => {
        // Si c'est la page company
        if (isCompanyPage) {
            if (index === 0) {
                return 'min-w-[200px]'; // ENSEIGNE
            }
            if (index === 1) {
                return 'min-w-[150px]'; // GROUPE
            }
            if (index === 2) {
                return 'min-w-[150px]'; // REJOINT LE
            }
        }
        // Si c'est la page qualification
        if (isQualificationPage) {
            if (index === 0) {
                return 'min-w-[200px]'; // NOM DU POSTE
            }
            if (index === 1) {
                return 'min-w-[150px]'; // SECTEUR
            }
            if (index === 2) {
                return 'min-w-[150px]'; // CRÉÉ LE
            }
        }
        return '';
    };

    return (
        <>
            <tr className="sticky top-0 z-30 border-b border-gray-900">
                {
                    champsHeader?.map((item, key) => {
                        // Rendre la première colonne sticky à gauche uniquement pour les viviers
                        const isStickyLeft = pathname && (pathname.includes('rating-treated') || pathname.includes('rating-untreated')) && key === 0;
                        const headerBgClass = isStickyLeft ? 'bg-white' : 'bg-gray-50';
                        return (
                        <th 
                            key={key} 
                                className={`sticky top-0 ${isStickyLeft ? 'left-0 z-30' : 'z-30'} ${headerPyClass} text-left text-sm font-medium text-gray-700 ${headerBgClass} border-b border-gray-100 whitespace-nowrap ${key === 0 ? 'pl-4 pr-2' : 'px-2'} ${getMinWidthClass(key, item, pathname)} ${getWidthClass(key, item, pathname)} transition-colors`}
                                style={isStickyLeft && hasHorizontalScroll ? { boxShadow: '2px 0 0 0 rgba(243, 244, 246, 1)' } : {}}
                        >
                            {item.toUpperCase()}
                        </th>
                        );
                    })
                }
                {!isNocompletedPage && (
                    <th className={`sticky top-0 z-30 ${headerPyClass} pl-2 pr-3 text-left text-sm font-medium text-gray-700 bg-gray-50 border-b border-gray-50 w-fit`}></th>
                )}
            </tr>
        </>
    );
};

export default Thead;